module.exports = __webpack_public_path__ + "static/media/logo.e0a682c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 410
// module chunks = 1